import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2 from "./Components/NaviBarv2";
import Footer from "./Components/Footer";
import { Container, Row, Col, Card, Badge, Button, Alert } from "react-bootstrap";

const DOCS_BASE =
  (process.env.REACT_APP_API_URL || "http://localhost:8001").replace(/\/$/, "") +
  "/api/documents";
const ACCENT = "#198754";

const CARD_BODY =
  "d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center gap-3";

const numStyle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
};

const noteStyle = {
  background: "#e8f3ec",
  color: "#1b5e37",
  borderRadius: 4,
};

// Последовательность действий (текст — из оригинальной страницы)
const PAY_STEPS = [
  {
    n: 1,
    title: "Получить Экспертное заключение",
    text:
      "Получить Экспертное заключение на статью (см. инструкцию во вкладке «Получение Экспертного заключения»).",
    note: "Без ЭЗ заявка не будет принята.",
  },
  {
    n: 2,
    title: "Получить инвойс от журнала",
    text: "Запросить инвойс у журнала. Указать реквизиты плательщика.",
    note: "Если публикация в международном журнале требуется перевод инвойса на русский.",
  },
  {
    n: 3,
    title: "Заполнить заявку на закупку",
    text: "Заполнить форму «Заявка на закупку»: ЦФО, бюджет, цель, сумма.",
    note: "Используйте шаблон и пример ниже.",
  },
  {
    n: 4,
    title: "Заполнить поручение",
    text: "Заполнить форму «Поручение» — согласование оплаты агентом.",
    note: "Используйте шаблон и пример ниже.",
  },
  {
    n: 5,
    title: "Направить пакет документов",
    text: "Собрать пакет и направить на почту: glc@siriusuniversity.ru",
    note: "Убедитесь, что все документы подписаны.",
  },
];

const PAY_EXAMPLES = [
  {
    icon: "📄",
    name: "Пример заполнения заявки на закупку",
    desc: "Посмотрите, как заполняется форма",
    file: "example-purchase-request.pdf",
  },
  {
    icon: "📄",
    name: "Пример заполнения поручения",
    desc: "Посмотрите, как заполняется форма",
    file: "example-order.pdf",
  },
];

const PAY_TEMPLATES = [
  {
    icon: "📊",
    name: "Заявка на закупку",
    desc: "Файл для заполнения в Excel",
    file: "template-purchase-request.xlsx",
    download: "Шаблон Заявка на закупку.xlsx",
  },
  {
    icon: "📄",
    name: "Поручение",
    desc: "Файл для заполнения в Word",
    file: "template-order.docx",
    download: "Шаблон Поручение.docx",
  },
];

function PublicationPayment() {
  return (
    <div className="App">
      <NaviBarv2 />

      <Container className="py-4 text-start">
        {/* Заголовок */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">Оплата публикации статьи</h1>
          <p className="text-muted mb-2">
            АНОО ВО «Университет «Сириус» — процесс оплаты публикации научной
            статьи в международном журнале
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            Пакет документов для оплаты публикации
          </Badge>
        </div>

        {/* Последовательность действий */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Последовательность действий
          </h2>
          <Row className="g-3">
            {PAY_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    <div style={numStyle}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-2">{s.text}</p>
                    <div className="small px-2 py-1" style={noteStyle}>
                      {s.note}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Alert variant="success" className="mt-3 mb-2 text-start">
            <strong>📧 Куда отправлять:</strong> glc@siriusuniversity.ru
          </Alert>
          <Alert variant="warning" className="mb-0 text-start">
            <strong>Состав пакета:</strong> Заявка на закупку, скан Экспертного
            заключения, Статья и перевод (если иностранный журнал), Инвойс и
            перевод (если иностранный журнал), Поручение.
          </Alert>
        </section>

        {/* Примеры заполнения */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📋 Примеры заполнения
          </h2>
          <h3 className="h5 fw-bold mb-3" style={{ color: ACCENT }}>
            📊 Примеры заполненных документов
          </h3>
          <Row className="g-3">
            {PAY_EXAMPLES.map((e, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div>
                      <div className="fw-semibold">
                        {e.icon} {e.name}
                      </div>
                      <div className="text-muted small">{e.desc}</div>
                    </div>
                    <Button
                      variant="outline-success"
                      href={`${DOCS_BASE}/payment/${e.file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      Смотреть PDF
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>

        {/* Шаблоны для заполнения */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📄 Шаблоны для заполнения
          </h2>
          <h3 className="h5 fw-bold mb-3" style={{ color: ACCENT }}>
            📎 Скачать шаблоны
          </h3>
          <Row className="g-3">
            {PAY_TEMPLATES.map((t, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div>
                      <div className="fw-semibold">
                        {t.icon} {t.name}
                      </div>
                      <div className="text-muted small">{t.desc}</div>
                    </div>
                    <Button
                      variant="success"
                      href={`${DOCS_BASE}/payment/${t.file}`}
                      download={t.download}
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      📥 Скачать
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          <Alert variant="info" className="mt-3 mb-0 text-start">
            <strong>
              🧾 Реквизиты для заполнения инвойса (для иностранных журналов):
            </strong>
            <pre
              className="mt-2 mb-1 p-3 rounded"
              style={{
                background: "#f8f5f0",
                border: "1px solid #d8d2c2",
                whiteSpace: "pre-wrap",
                fontFamily: "Consolas, monospace",
                fontSize: 13,
                color: "#1b2a4a",
              }}
            >
              {`ANDREY MOSKALEV
AVA AXONA D.O.O. BEOGRAD (PIB 113624345)
DANILA LEKICA-SPANCA 1/2 BEOGRAD, NOVI BEOGRAD
11070, BELGRADE SERBIA`}
            </pre>
            <div className="text-muted small">
              Эти данные указываются в личном кабинете при запросе инвойса у
              издательства.
            </div>
          </Alert>
        </section>

        <Alert variant="info" className="mb-0 text-start">
          <strong>ℹ️ Примечание:</strong> После согласования заявки в 1С отдел
          закупок берет в работу данную потребность. Все документы должны быть
          подписаны уполномоченными лицами.
        </Alert>
      </Container>

      <Footer />
    </div>
  );
}

export default PublicationPayment;
